// Parse an in-app path (optionally with a query string) into the page slug plus a
// generic `focus` object built from the query params, and the inverse. Used by
// App.js (direct-URL load + handleNavigate) and the Notifications inbox, so a
// notification can deep-link to the specific item it's about (e.g.
// `/incident-reports?id=45`). Backward-compatible: a bare slug yields focus=null
// and behaves exactly as before.

export function parseAppPath(raw) {
  const str = String(raw || '');
  const q = str.indexOf('?');
  const path = q === -1 ? str : str.slice(0, q);
  const query = q === -1 ? '' : str.slice(q + 1);
  const pageName = path.replace(/^\//, '').replace(/\/$/, '') || 'dashboard';
  let focus = null;
  if (query) {
    const entries = {};
    for (const [k, v] of new URLSearchParams(query)) entries[k] = v;
    if (Object.keys(entries).length) focus = entries;
  }
  return { pageName, focus };
}

export function buildPath(pageName, focus) {
  const base = pageName === 'dashboard' ? '/' : `/${pageName}`;
  if (focus && typeof focus === 'object' && Object.keys(focus).length) {
    const qs = new URLSearchParams(focus).toString();
    if (qs) return `${base}?${qs}`;
  }
  return base;
}
